import { useNavigate } from 'react-router-dom';

export default function CaseStudies() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/case');
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  const cases = [
    {
      category: 'Одежда Plus Size',
      metric: '+312%',
      metricLabel: 'рост органического трафика',
      description: 'Разработка сайта-стратегии с SEO-архитектурой под нишевую аудиторию. Выход в топ-3 Google за 45 дней.',
      tag: 'SEO + Веб-сайт',
    },
    {
      category: 'Косметика и уход',
      metric: '×2.8',
      metricLabel: 'рост конверсии в заявку',
      description: 'Полная переработка воронки продаж: от карточки товара до кнопки «Купить». Мобильная вёрстка Mobile-First.',
      tag: 'Конверсия + UX',
    },
    {
      category: 'Здоровое питание',
      metric: '-40%',
      metricLabel: 'снижение стоимости лида',
      description: 'Внедрение квизов и лид-магнитов. Квалификация клиентов до первого звонка. Рост среднего чека.',
      tag: 'Лидогенерация',
    },
  ];

  return (
    <section className="py-24" style={{ background: '#F8F9FA' }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-sm font-semibold tracking-widest uppercase mb-4" style={{ color: '#C5A880', fontFamily: 'Montserrat, sans-serif' }}>
            Реализованные проекты
          </p>
          <h2
            className="text-4xl md:text-5xl font-bold mb-6"
            style={{ color: '#1A2B4C', fontFamily: 'Playfair Display, serif' }}
          >
            Кейсы: Как работает система на практике
          </h2>
          <div className="w-16 h-0.5 mx-auto mb-6" style={{ background: '#C5A880' }}></div>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: '#4A5568', fontFamily: 'Montserrat, sans-serif' }}>
            Мы не скрываем результаты. Вот примеры того, как внедрение стратегии влияет на выручку в реальном времени.
          </p>
        </div>

        {/* Case cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-14">
          {cases.map((c, i) => (
            <div
              key={i}
              className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer"
              style={{ border: '1px solid #E8E0D5' }}
              onClick={handleClick}
            >
              {/* Top accent bar */}
              <div className="h-1 w-full" style={{ background: '#C5A880' }}></div>

              <div className="p-8">
                {/* Tag */}
                <span
                  className="inline-block text-xs font-semibold tracking-wider uppercase px-3 py-1 rounded-full mb-6"
                  style={{ background: '#1A2B4C', color: '#C5A880', fontFamily: 'Montserrat, sans-serif' }}
                >
                  {c.tag}
                </span>

                {/* Metric */}
                <div
                  className="text-5xl font-bold mb-1 group-hover:scale-105 transition-transform duration-300"
                  style={{ color: '#1A2B4C', fontFamily: 'Playfair Display, serif' }}
                >
                  {c.metric}
                </div>
                <p className="text-sm font-medium mb-4" style={{ color: '#C5A880', fontFamily: 'Montserrat, sans-serif' }}>
                  {c.metricLabel}
                </p>

                {/* Divider */}
                <div className="w-10 h-px mb-4" style={{ background: '#E8E0D5' }}></div>

                {/* Category */}
                <h3 className="text-lg font-bold mb-3" style={{ color: '#1A2B4C', fontFamily: 'Playfair Display, serif' }}>
                  {c.category}
                </h3>
                <p className="text-sm leading-relaxed" style={{ color: '#6B7280', fontFamily: 'Montserrat, sans-serif' }}>
                  {c.description}
                </p>
              </div>

              {/* Footer */}
              <div className="px-8 pb-6">
                <span
                  className="inline-flex items-center gap-2 text-sm font-semibold transition-colors duration-200"
                  style={{ color: '#C5A880', fontFamily: 'Montserrat, sans-serif' }}
                >
                  Читать кейс <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={handleClick}
            className="inline-flex items-center gap-3 px-10 py-4 rounded-xl font-semibold text-base transition-all duration-300 hover:opacity-90 hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
            style={{ background: '#1A2B4C', color: '#C5A880', fontFamily: 'Montserrat, sans-serif' }}
          >
            <i className="ri-folder-open-line text-xl"></i>
            Изучить все реализованные проекты
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
